module.exports = __webpack_public_path__ + "img/crizal-easy.f9dfd18a.svg";